module.exports = __webpack_public_path__ + "static/media/leftright.bbe41727.mov";